import React from 'react';
import ApprovalDashboard from './components/ApprovalDashboard';
import AdminLayout from '../../components/layouts/AdminLayout';

const AdministrativeWorkflowCenter = ({ embedded = false, onBack }) => {
    const content = (
        <div className="space-y-6">
            {!embedded && (
                <div>
                    <h1 className="text-2xl font-bold tracking-tight text-slate-900">Approval Centre</h1>
                    <p className="text-sm text-muted-foreground mt-0.5">Manage, review, and track all institutional workflow requests.</p>
                </div>
            )}
            <ApprovalDashboard onBack={onBack} />
        </div>
    );

    if (embedded) return content;

    return (
        <AdminLayout title="Approval Centre">
            {content}
        </AdminLayout>
    );
};

export default AdministrativeWorkflowCenter;
